import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "js-page-content",
  role: "main",
  class: "page-content"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<ol class=\"breadcrumb page-breadcrumb\"><li class=\"breadcrumb-item\"><a href=\"javascript:void(0);\">SmartAdmin</a></li><li class=\"breadcrumb-item\">Category</li><li class=\"breadcrumb-item\">Sub-category</li><li class=\"breadcrumb-item active\">Page Title</li><li class=\"position-absolute pos-top pos-right d-none d-sm-block\"><span class=\"js-get-date\"></span></li></ol><div class=\"subheader\"><h1 class=\"subheader-title\"><i class=\"subheader-icon fal fa-globe\"></i> Vueselect <span class=\"fw-300\">サンプル</span><sup class=\"badge badge-primary fw-500\">STICKER</sup><small> Insert page description or punch line </small></h1><div class=\"subheader-block\">Right Subheader Block</div></div><div class=\"alert alert-primary\"><div class=\"d-flex flex-start w-100\"><div class=\"mr-2 hidden-md-down\"><span class=\"icon-stack icon-stack-lg\"><i class=\"base base-6 icon-stack-3x opacity-100 color-primary-500\"></i><i class=\"base base-10 icon-stack-2x opacity-100 color-primary-300 fa-flip-vertical\"></i><i class=\"ni ni-blog-read icon-stack-1x opacity-100 color-white\"></i></span></div><div class=\"d-flex flex-fill\"><div class=\"flex-fill\"><span class=\"h5\">注意事項!</span><p>特に注意事項はないです</p><p class=\"m-0\"> Follow a slogal with a useful link or call to action <a href=\"#\" target=\"_blank\">Call to action &gt;&gt;</a></p></div></div></div></div>", 3)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-12" }
const _hoisted_7 = {
  id: "panel-x",
  class: "panel"
}
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"panel-hdr\"><h2>vue-select</h2><div class=\"panel-toolbar\"><button class=\"btn btn-panel waves-effect waves-themed\" data-action=\"panel-collapse\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Collapse\"></button><button class=\"btn btn-panel waves-effect waves-themed\" data-action=\"panel-fullscreen\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Fullscreen\"></button><button class=\"btn btn-panel waves-effect waves-themed\" data-action=\"panel-close\" data-toggle=\"tooltip\" data-offset=\"0,10\" data-original-title=\"Close\"></button></div></div>", 1)
const _hoisted_9 = { class: "panel-container show" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "loader" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-spinner-third fa-spin-4x fs-xxl" })
], -1)
const _hoisted_11 = { class: "panel-content" }
const _hoisted_12 = { class: "frame-wrap" }
const _hoisted_13 = { class: "demo" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vSelect = _resolveComponent("vSelect")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createTextVNode(" 値とキー(簡単にやるならoptionsに直接値を設定可能だが実戦では基本使わない) "),
                  _createVNode(_component_vSelect, { options: [
                      { label: 'Canada', code: 'ca' },
                      { label: 'Japan', code: 'jp' },
                      { label: 'USA', code: 'en' },
                    ] }),
                  _createTextVNode(" 値だけなら配列でOK "),
                  _createVNode(_component_vSelect, { options: ['Canada', 'United States'] }),
                  _createTextVNode(" 値を紐付ける 値のキーはlabelとcodeである必要がある"),
                  _hoisted_14,
                  _createTextVNode(" ※label=\"UserShowName\"で、キーの書き換えが可能。値の書き換えはreduce"),
                  _hoisted_15,
                  _createTextVNode(" 以下の例では、選択値がselectedにバインドされる。 "),
                  _createVNode(_component_vSelect, {
                    modelValue: _ctx.selected,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected) = $event)),
                    options: _ctx.optionsOp
                  }, null, 8, ["modelValue", "options"]),
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSelect1())),
                    type: "button",
                    class: "btn btn-primary waves-effect waves-themed"
                  }, " 選択値の取得 "),
                  _hoisted_16,
                  _createTextVNode(" " + _toDisplayString(_ctx.selected) + " ", 1),
                  _hoisted_17,
                  _hoisted_18,
                  _hoisted_19,
                  _createTextVNode(" マルチセレクト multipleを入れるだけ "),
                  _createVNode(_component_vSelect, {
                    multiple: "",
                    modelValue: _ctx.selected2,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selected2) = $event)),
                    options: _ctx.optionsOp2
                  }, null, 8, ["modelValue", "options"]),
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showSelect2())),
                    type: "button",
                    class: "btn btn-primary waves-effect waves-themed"
                  }, " 選択値の取得 "),
                  _hoisted_20,
                  _createTextVNode(" " + _toDisplayString(_ctx.selected2) + " ", 1),
                  _hoisted_21,
                  _hoisted_22,
                  _hoisted_23,
                  _createTextVNode(" APIで取得したデータでセレクトボックスを作成"),
                  _hoisted_24,
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.creSelect())),
                    type: "button",
                    class: "btn btn-primary waves-effect waves-themed",
                    id: "btn"
                  }, " 読込 "),
                  _createVNode(_component_vSelect, {
                    multiple: "",
                    modelValue: _ctx.selected3,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selected3) = $event)),
                    options: _ctx.optionsOp3,
                    label: "c_series_name"
                  }, null, 8, ["modelValue", "options"]),
                  _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showSelect3())),
                    type: "button",
                    class: "btn btn-primary waves-effect waves-themed"
                  }, " 選択値の取得 "),
                  _hoisted_25,
                  _createTextVNode(" " + _toDisplayString(_ctx.selected3) + " ", 1),
                  _hoisted_26,
                  _hoisted_27,
                  _hoisted_28
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}